module.exports = __webpack_public_path__ + "static/media/fnzi2.1830ac13.1830ac13.png";